import React from 'react'
import _ from 'lodash'
import './mutiDayDiscounts.css'

import { Header, Columns } from '../../../../components/elements'

const MultiDayDiscounts = ({ multiDayDiscounts }) => {
  return (
    <>
      <div className='is-flex is-align-items-center'>
        <h3 className="multidaydiscount-name">Multi-Day Discounts</h3>
        <i class="fa-solid fa-tags ml-2 mb-1"></i>
      </div>
      {multiDayDiscounts.length > 0 && (
        <table className="multidaydiscount-table">
          <tbody>
            {_.orderBy(multiDayDiscounts, 'discount_days', 'asc').map(
              (discount, i) => (
                <tr className="description-row" key={i}>
                  <td className="first-column">
                    {discount.discount_days}
                    {i === multiDayDiscounts.length - 1 ? '+' : ''} days
                  </td>
                  <td className="second-column">
                    {discount.discount_percent}% Off
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      )}
    </>
  )
}

export default MultiDayDiscounts
